'use strict';

/**
 * The MUI palette client-web2 and admin-web share: client-web2's platform
 * palette in the light (client-web2/lib/theme/palettes.ts), and admin-web's
 * whole palette (admin-web/src/index.jsx). Plain values, so each app calls
 * `createTheme` with its own MUI.
 */
module.exports.palette = {
  primary: {
    // The one indigo (stories/story-202609221835-public-restyle.md, slice 0).
    // White on it is 6.8:1, on `dark` 9.2:1.
    main: '#4052b5',
    dark: '#30418f',
    contrastText: '#fff',
  },
  secondary: {
    main: '#4052b5',
  },
  error: {
    // MUI's red[700]: red.A400 is 3.84:1 on white, under WCAG AA's 4.5:1.
    main: '#d32f2f',
  },
};
